<template>
    <v-layout wrap row
              class="background"
              v-bind:style="{'background-image': 'url(' + background + ')'}">
        <v-flex shrink xs12 class="area_logo">
            <v-img :src="logo" class="logo" :transition="false">
            </v-img>
        </v-flex>
        <v-flex grow xs12 class="area-select">
            <v-layout wrap fill-height fluid row justify-space-between>
                <v-layout wrap row class="container_select">
                    <v-flex xs12 class="title">
                        {{$vuetify.t('$vuetify.CitySelect.selectCity')}}
                    </v-flex>
                    <v-flex xs12 class="scrollbox">
                        <ul class="list">


                            <!-- Apollo watched Graphql query -->
                            <ApolloQuery ref="cities_query"
                                         clientId="clientPublic"
                                         :query="require('../graphql/queries/cities.gql')">
                                <template v-slot:default="{result: { data }}">

                                    <template v-if="data">

                                        <smooth-picker ref="smoothPicker"
                                                       :data="collectDataForSelect()"
                                                       :change="change"/>

                                    </template>

                                </template>
                            </ApolloQuery>


                        </ul>
                    </v-flex>
                </v-layout>

                <v-layout wrap>
                    <v-flex xs12>
                        <v-btn color="primary button-go"
                               @click="goToCustomer">
                            {{ $vuetify.t("$vuetify.CitySelect.go")}}
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 pa-2 class="iconscroll_container">
                        <v-icon>mdi-gesture-swipe-vertical</v-icon>
                    </v-flex>
                </v-layout>

            </v-layout>
        </v-flex>
        <v-flex class="footer" align-self-end>
            {{ $vuetify.t("$vuetify.CitySelect.copyright")}}
        </v-flex>
    </v-layout>
</template>


<script>

    import background from "../assets/backgroundSelectCity.jpg"
    import logo from "../assets/logo_app_ecospazio.png"
    import _ from "lodash"


    export default {
        data: function () {

            return {
                logo,
                background,
                collectedCities: [],
                selectedCity: null

            }
        },
        activated() {
            this.$refs.cities_query.$apollo.queries.query.refetch()
        },
        methods: {
            change(gIndex, iIndex) {
                this.selectedCity = this.collectedCities[iIndex].value

            },
            collectDataForSelect() {
                let printedList = []
                if (this.$refs.cities_query && this.$refs.cities_query.result) {

                    const nodes = this.$refs.cities_query.result.data.customers.nodes
                    this.collectedCities = _.map(nodes, (el) => {
                        const elName = this.$options.filters.uppercase(el.name)
                        printedList.push(elName)
                        return {
                            text: elName,
                            value: el.pwaDomain
                        }

                    })


                }

                return [{
                    currentIndex: 2,
                    flex: 1,
                    list: printedList,
                    textAlign: 'center',
                    className: 'row-group'
                }]

            },
            goToCustomer(e){

                let port = ""

                if (window.location.port !== "80" && window.location.port !== "443") {
                    port = ":" + window.location.port
                }

                window.location = "//" + this.selectedCity + port


            }

        }

    }
</script>


<style scoped lang="scss">
    .background {
        height: 100%;
        width: 100%;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
        /*display: flex;*/
        /*flex-direction: column;*/
        /*align-content: center;*/
        /*justify-content: space-between;*/
        /*flex-wrap: wrap;*/


        .area_logo {
            padding: 15px;

            .logo {
                margin: 0 auto;
                width: 110px;
            }
        }

        .area-select {
            height: calc(100% - 205px);
        }

        .footer{
            height: 25px;
            background-color: #135e7d;
            line-height: 25px;
        }

        .container_select {
            //height: 350px;
            margin: 0px 15px 60px 15px;
            width: 100%;


            .title {
                color: var(--v-primary-base);
                font-size: 21px !important;
                padding: 15px;
                width: 100%;
                text-align: center;
            }

            .scrollbox {
                .list {
                    list-style: none;

                    li {
                        font-size: 18px;
                        margin-top: 10px;
                        margin-bottom: 10px;
                    }
                }
            }
        }

        .iconscroll_container {
            .iconScroll {
                margin: auto;
            }
        }

        .button-go {
            color: var(--v-secondary-base)
        }
    }


</style>

<style lang="scss" scoped>
    .scrollbox {
        & /deep/ .smooth-picker {
            background-color: transparent;

            .smooth-handle-layer {
                .smooth-bottom, .smooth-top {
                    background: none;
                    border-color: var(--v-primary-base);

                }

            }
        }
    }

</style>
